import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { HomeVisit } from "@/@types/esus/HomeVisit";

type IndicatorEsfC4CitizensAcsVisitsHistoryItemProps = {
	homeVisit: HomeVisit;
};

export function IndicatorEsfC4CitizensAcsVisitsHistoryItem({
	homeVisit,
}: Readonly<IndicatorEsfC4CitizensAcsVisitsHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{homeVisit.healthTeam?.name?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{homeVisit.healthUnit?.name?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{homeVisit.professional?.name?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{homeVisit.cbo?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
		</>
	);
}
